import _asyncToGenerator from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "/opt/build/repo/node_modules/@babel/runtime/regenerator";
import config from '../config';
import { processXhr } from './utils';

var signUp = function signUp(username, passwordToken, ecKeyData, passwordSalts, keySalts, email, profile, passwordBasedBackup, sessionLength) {
  return new Promise(function (resolve, reject) {
    var xhr = new XMLHttpRequest();
    var method = 'POST';
    var url = "".concat(config.getEndpoint(), "/api/auth/sign-up?appId=").concat(config.getAppId(), "&userbaseJsVersion=").concat(config.USERBASE_JS_VERSION);
    var data = JSON.stringify({
      username: username,
      passwordToken: passwordToken,
      ecKeyData: ecKeyData,
      passwordSalts: passwordSalts,
      keySalts: keySalts,
      email: email,
      profile: profile,
      passwordBasedBackup: passwordBasedBackup,
      sessionLength: sessionLength
    });
    xhr.open(method, url);
    xhr.setRequestHeader('Content-Type', 'application/json');
    xhr.send(data);
    processXhr(xhr, resolve, reject);
  });
};

var getPasswordSalts = function getPasswordSalts(username) {
  return new Promise(function (resolve, reject) {
    var xhr = new XMLHttpRequest();
    var method = 'GET';
    var url = "".concat(config.getEndpoint(), "/api/auth/get-password-salts?appId=").concat(config.getAppId(), "&username=").concat(encodeURIComponent(username), "&userbaseJsVersion=").concat(config.USERBASE_JS_VERSION);
    xhr.open(method, url);
    xhr.send();
    processXhr(xhr, resolve, reject);
  });
};

var signIn = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(username, passwordToken, sessionLength) {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", new Promise(function (resolve, reject) {
              var xhr = new XMLHttpRequest();
              var method = 'POST';
              var url = "".concat(config.getEndpoint(), "/api/auth/sign-in?appId=").concat(config.getAppId(), "&userbaseJsVersion=").concat(config.USERBASE_JS_VERSION);
              var data = JSON.stringify({
                username: username,
                passwordToken: passwordToken,
                sessionLength: sessionLength
              });
              xhr.open(method, url);
              xhr.setRequestHeader('Content-Type', 'application/json');
              xhr.send(data);
              processXhr(xhr, resolve, reject);
            }));

          case 1:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function signIn(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();

var signInWithSession = function signInWithSession(sessionId, sessionLength) {
  return new Promise(function (resolve, reject) {
    var xhr = new XMLHttpRequest();
    var method = 'POST';
    var url = "".concat(config.getEndpoint(), "/api/auth/sign-in-with-session?appId=").concat(config.getAppId(), "&sessionId=").concat(sessionId, "&userbaseJsVersion=").concat(config.USERBASE_JS_VERSION);
    var data = JSON.stringify({
      sessionLength: sessionLength
    });
    xhr.open(method, url);
    xhr.setRequestHeader('Content-Type', 'application/json');
    xhr.send(data);
    processXhr(xhr, resolve, reject);
  });
};

var getServerPublicKey = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            return _context2.abrupt("return", new Promise(function (resolve, reject) {
              var xhr = new XMLHttpRequest();
              var method = 'GET';
              var url = "".concat(config.getEndpoint(), "/api/auth/server-public-key?&userbaseJsVersion=").concat(config.USERBASE_JS_VERSION);
              var responseType = 'arraybuffer';
              xhr.open(method, url);
              xhr.responseType = responseType;
              xhr.send();
              processXhr(xhr, resolve, reject);
            }));

          case 1:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function getServerPublicKey() {
    return _ref2.apply(this, arguments);
  };
}();

var getPublicKey = function getPublicKey(username) {
  return new Promise(function (resolve, reject) {
    var xhr = new XMLHttpRequest();
    var method = 'GET';
    var url = "".concat(config.getEndpoint(), "/api/public-key?appId=").concat(config.getAppId(), "&username=").concat(encodeURIComponent(username), "&userbaseJsVersion=").concat(config.USERBASE_JS_VERSION);
    xhr.open(method, url);
    xhr.send();
    processXhr(xhr, resolve, reject);
  });
};

var uploadBundleChunk = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(chunk, token) {
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            return _context3.abrupt("return", new Promise(function (resolve, reject) {
              var xhr = new XMLHttpRequest();
              var method = 'POST';
              var url = "".concat(config.getEndpoint(), "/api/bundle-chunk?userbaseJsVersion=").concat(config.USERBASE_JS_VERSION);
              xhr.setRequestHeader('Authorization', 'Bearer ' + token);
              xhr.open(method, url);
              xhr.send(chunk);
              processXhr(xhr, resolve, reject);
            }));

          case 1:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function uploadBundleChunk(_x4, _x5) {
    return _ref3.apply(this, arguments);
  };
}();

export default {
  signUp: signUp,
  getPasswordSalts: getPasswordSalts,
  signIn: signIn,
  signInWithSession: signInWithSession,
  getServerPublicKey: getServerPublicKey,
  getPublicKey: getPublicKey,
  uploadBundleChunk: uploadBundleChunk
};